export default __webpack_public_path__ + "static/media/m870.2f0ddd4d.svg";